import { render, staticRenderFns } from "./ListUserProducts.vue?vue&type=template&id=96f086ea&scoped=true"
import script from "./ListUserProducts.vue?vue&type=script&lang=js"
export * from "./ListUserProducts.vue?vue&type=script&lang=js"
import style0 from "./ListUserProducts.vue?vue&type=style&index=0&id=96f086ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f086ea",
  null
  
)

export default component.exports